export const BUTTONS_INFO = {
  deliveryDateType: [
    {
      label: "Text",
      value: "Text",
      name: "deliveryDateType",
    },
    {
      label: "Number of Days",
      value: "Number",
      name: "deliveryDateType",
    },
  ],
  missedProductCarouselEnabledSalesRep: [
    {
      label: "Yes",
      value: "true",
      name: "missedProductCarouselEnabledSalesRep",
    },
    {
      label: "No",
      value: "false",
      name: "missedProductCarouselEnabledSalesRep",
    },
  ],
  missedProductCarouselEnabledRetailer: [
    {
      label: "Yes",
      value: "true",
      name: "missedProductCarouselEnabledRetailer",
    },
    {
      label: "No",
      value: "false",
      name: "missedProductCarouselEnabledRetailer",
    },
  ],
  missedProductCarouselOptions: [
    {
      label: "Recommended Products",
      value: "Recommended Products",
      name: "missedProductCarouselOption",
    },
    {
      label: "Personalised Curated Basket",
      value: "Personalised Curated Basket",
      name: "missedProductCarouselOption",
    },
  ],
  orderValidationType: [
    {
      label: "Only Minimum",
      value: "min",
      name: "orderValidationType",
    },
    {
      label: "Only Maximum",
      value: "max",
      name: "orderValidationType",
    },
    {
      label: "Both Minimum and Maximum",
      value: "max,min",
      name: "orderValidationType",
    },
  ],
  orderingCriteriaType: [
    {
      label: "Only Value",
      value: "value",
      name: "orderingCriteriaType",
    },
    {
      label: "Only Quantity",
      value: "quantity",
      name: "orderingCriteriaType",
    },
    {
      label: "Both Value AND Quantity",
      value: "quantity,value,&",
      name: "orderingCriteriaType",
    },
    {
      label: "Both Value OR Quantity",
      value: "quantity,value,|",
      name: "orderingCriteriaType",
    },
  ],
};
export const INPUT_VALIDATION = {
  deliveryDateValue: {
    text: {
      min: 2,
      max: 16,
    },
    number: {
      min: 1,
      max: 2,
    },
  },
  deliveryTimeLabel: {
    min: 2,
    max: 12,
  },
  minMaxValueQuanitity : {
    min: 1,
    max: 5,
  }
};
export const CART_CONFIG_DOMAIN_NAME = "clientconfig";
export const CART_CONFIG_DOMAIN_TYPE = "order_configuration";
export const CART_CONFIG_OBJECT_NAMES = {
  orderFulfillmentTimeMessageConfig: "orderFulfillmentTimeMessage",
  orderFulfillmentTimeConfig: "orderFulfillmentTime",
  fullFilledByLabelConfig: "fullFilledByLabel",
  missedItemBasket: "missedItemBasket",
  missedRecommendationTypeMapping: "missedRecommendationTypeMapping",
  discardSuggQtyInMissedRecoPopup: "discardSuggQtyInMissedRecoPopup",
  showMissedRecoPopup: "showMissedRecoPopup",
  orderingConditions: "orderingConditions",
  persistentCartNavigationBar : "persistentCartNavigationBar"
};
